import React from "react";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  container: {
    padding: "4px 4px 12px 0px",
    minWidth: "140px",
    maxWidth:"150px",
    flex:1,
    display: "flex",
    boxSizing: "border-box",
    lineHeight: "20px",
  },
  label: {
    width: "65%",
    overflowWrap: "break-word",
  },
  value: {
    width: "35%",
    overflowWrap: "break-word",
  },
});

const Detail = ({ label, value, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.label}>{label}</div>
      <div className={classes.value}>{value}</div>
    </div>
  );
};

export default withStyles(styles)(Detail)